import useGetAvatars from '@/hooks/useGetAvatars';
import {
    AVATAR_PROPERTIES,
    INTERVENTION_CREATED_FROM_AVATAR_PROPERTY,
    INTERVENTIONS_ROUTE,
    NAVIGATION_ROUTE,
} from '@/utils/CONST';
import { Avatar } from '@/utils/types';
import { Box, Link } from '@mui/material';
import { extractIdFromUriId } from 'base-tools-360smartconnect/utils/id';
import { nth } from 'lodash';
import { FunctionField, ReferenceOneField, TextField, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router';

interface Props {
    intervention: Avatar;
}

const LinkToInterventionButton = ({ intervention }: Props) => {
    const navigate = useNavigate();
    const translate = useTranslate();

    const { avatars: places, isLoading: isLoadingPlace } = useGetAvatars({
        filters: {
            id: intervention?.parent,
            serialization_groups: ['read_avatar_parent'],
        },
    });

    const place = nth(places);

    const { avatars: sites, isLoading: isLoadingSites } = useGetAvatars({
        filters: {
            id: place?.parent,
            serialization_groups: ['read_avatar_parent'],
        },
    });

    const site = nth(sites);

    const { avatars: clients, isLoading: isLoadingClients } = useGetAvatars({
        filters: {
            id: site?.parent,
            serialization_groups: ['read_avatar_parent'],
        },
    });

    const client = nth(clients);

    const isLoading = isLoadingPlace || isLoadingSites || isLoadingClients;
    const resolvedClientId = extractIdFromUriId(client?.id ?? '');
    const resolvedSiteId = extractIdFromUriId(site?.id ?? '');
    const resolvedPlaceId = extractIdFromUriId(place?.id ?? '');

    const handleClick = () => {
        if (isLoading || resolvedClientId == null || resolvedSiteId == null || resolvedPlaceId == null) return;
        navigate(
            `/${NAVIGATION_ROUTE}/client/${resolvedClientId}/site/${resolvedSiteId}/place/${resolvedPlaceId}/${INTERVENTIONS_ROUTE}?filter=${encodeURIComponent(JSON.stringify({ alphaId: intervention.alphaId }))}`,
        );
    };

    return (
        <Link
            onClick={handleClick}
            sx={{ cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }}
        >
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <TextField source='alphaId' />

                <ReferenceOneField
                    reference={AVATAR_PROPERTIES}
                    target='avatar'
                    label='intervention.list.type'
                    filter={{ name: INTERVENTION_CREATED_FROM_AVATAR_PROPERTY }}
                >
                    <FunctionField render={({ value }: any) => translate(`intervention.list.${value}`)} />
                </ReferenceOneField>
            </Box>
        </Link>
    );
};

export default LinkToInterventionButton;
